import * as R from "ramda";
import React, {Component, Fragment} from "react";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import MasterPackageModifying from "./components/MasterPackageModifying";
import MasterPackageFilter from "./components/MasterPackageFilter";
import Api from "../../../Services/Api";
import {flattenFormGroupObject, getValueFromArrayDDL, removeNullFields} from "../../common/mapper";
import {formGroup, tableColumns} from "./config/config";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import {getValueItemFromArrayDDL} from "./util";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {contructQueryParam, fetchDataAsync} from "../../../Services/Utils";
import {HttpStatus} from "../../common/Constants";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";

class MasterPackage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modifyingVisible: false,
            copyVisible: false,
            warningVisible: false,
            inputValue: null,
            warningMessage: null,
            warningAction: null,
            tableColumns: [
                ...tableColumns.mainPage,
                {
                    name: "",
                    label: "Action",
                    options: {
                        customBodyRender: (_, tableMeta) => {
                            return (
                                <FlexView vAlignContent="center" style={{gap: 10}}>
                                    <SimpleButton
                                        category="action_button"
                                        style={{backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}}
                                                 className="fa fa-lw fa-pencil-alt"/>}
                                        onClick={() => this.handleModifyingModalVisibility(tableMeta.rowIndex)}
                                    />
                                    <ToggleButton
                                        value={R.equals(this.state.dataTable[tableMeta.rowIndex].status, "ACTIVE")}
                                        onToggle={() => this.handleToggleClick(tableMeta.rowIndex)}
                                    />
                                    <SimpleButton
                                        category="action_button"
                                        style={{backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-copy"/>}
                                        onClick={() => this.handleCopyModalVisibility(tableMeta.rowIndex)}
                                    />
                                </FlexView>
                            );
                        },
                        sort: false,
                    },
                },
            ],
            selectedData: null,
            selectedRowIndex: null,
            payload: null,
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
            filterVisible: false,
            submitedFilter: null,
            search: {
                packageName: null,
            },
            mainPageFilter: {
                key: {label: "Nama Paket", value: "packageName"},
                value: null
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: !R.isNil(index) ? prevValue.dataTable[index] : null,
            modifyingVisible: !prevValue.modifyingVisible,
        }));
    };

    handleCopyModalVisibility = async (index) => {
        if (!R.isNil(index)) {
            const selectedData = this.state.dataTable[index];
            let response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterPackageById,
                menuName: "Master Package",
                setError: this.props.setError,
                args: contructQueryParam({idPackage: selectedData.packageId}),
            })
            if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    copyVisible: !prevValue.copyVisible,
                    selectedData: selectedData,
                    inputValue: null,
                    errorMessage: null,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                copyVisible: !prevValue.copyVisible,
                selectedData: null,
                inputValue: null,
                errorMessage: null,
            }));
        }
    };

    handleWarningModalVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            warningVisible: !prevValue.warningVisible,
        }));
    };

    handleToggleClick = (rowIndex) => {
        this.setState((prevValue) => ({
            ...prevValue,
            // warningVisible: !prevValue.warningVisible,
            warningAction: "update",
            selectedRowIndex: rowIndex,
        }), () => this.handleChangeStatus());
    };

    handleSaveClick = (payload) => {
        this.setState((prevValue) => ({
            ...prevValue,
            warningVisible: !prevValue.warningVisible,
            warningAction: "save",
            payload: payload,
        }));
    };

    handleValueChange = ({ target }) => {
      this.setState((prevValue) => ({
        ...prevValue,
        inputValue: target.value,
      }));
    };

    handleCopy = async (e) => {
        this.handleTriggerLoading();
        e.preventDefault();

        if (!this.state.inputValue) {
            this.setState((prevValue) => ({
                ...prevValue,
                errorMessage: "Field belum diisi",
                loading: false,
            }));
            return;
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                errorMessage: null,
            }));
        }
        let request = {
            packageId: this.state.selectedData.packageId,
            packageName: this.state.inputValue
        };
        console.log(request);
        

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").copyMasterPackage,
            menuName: "Master Package",
            setError: this.props.setError,
            args: request,
        })
        console.log(res);
        
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                copyVisible: !prevValue.copyVisible,
                // submitedFilter: null,
                // search: {
                //     packageName: null
                // }
            }));
            await this.refetch();
        }
        this.handleTriggerLoading();
    };

    handleSubmit = async () => {
        if (R.equals(this.state.warningAction, "save")) {
            await this.handleSubmitModifying(this.state.payload)
            this.handleWarningModalVisibility();
        } else {
            await this.handleChangeStatus();
            this.handleSaveClick();
        }
    }

    handleSubmitModifying = async (data) => {
        this.handleTriggerLoading();
        let parsedData = {
            ...flattenFormGroupObject(data),
            packageGracePeriod: Number(flattenFormGroupObject(this.state.payload).packageGracePeriod) || null,
            listCabang: getValueFromArrayDDL(this.state.payload, "listCabang"),
            listVariant: getValueFromArrayDDL(this.state.payload, "listVariant"),
            listGift: getValueItemFromArrayDDL(this.state.payload, "listGift"),
            listOtherItem: getValueItemFromArrayDDL(this.state.payload, "listOtherItem"),
            listKSU: getValueItemFromArrayDDL(this.state.payload, "listKSU"),
            listPart: getValueItemFromArrayDDL(this.state.payload, "listPart"),
        };

        delete parsedData.packageSpecificCabang;

        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").saveMasterPackage,
            parsedData,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            // this.setState(prev=>({
            //     ...prev,
            //     submitedFilter: null,
            //     search: {
            //         packageName: null
            //     }
            // }), async () => await this.refetch())
            await this.refetch()
        }
        this.handleTriggerLoading();
    };

    handleChangeStatus = async () => {
        this.handleTriggerLoading();
        const {selectedRowIndex, dataTable} = this.state;
        const currentStatus = dataTable[selectedRowIndex].status;
        const newStatus = currentStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE";

        let data = dataTable[selectedRowIndex];
        let requestPayload = {
            packageId: data.packageId,
            status: newStatus,
        }

        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").updateStatusMasterPackage,
            requestPayload,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            // this.setState(prev=>({
            //     ...prev,
            //     submitedFilter: null,
            //     search: {
            //         packageName: null
            //     }
            // }), async () => await this.refetch())
            await this.refetch();
        }
        this.handleTriggerLoading();
    };

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;

        const filter = this.state.submitedFilter || {}
        const arrCabang = filter.cabangBerlaku;
        const activeFilter = this.state.submitedFilter
          ? {
              ...filter,
              cabangBerlaku:
                arrCabang.length > 0
                  ? arrCabang.map((item) => item?.value)
                  : null,
                noPeriod: filter?.noPeriod === null ? null : filter?.noPeriod?.value
            }
          : this.state.search;

        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));

        await this.fetchData({
            ...removeNullFields(activeFilter),
            page: page,
            limit: limit
        });

        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        const limit = tableState.rowsPerPage;

        const filter = this.state.submitedFilter || {}
        const arrCabang = filter.cabangBerlaku;
        const activeFilter = filter
          ? {
              ...filter,
              cabangBerlaku:
                arrCabang?.length > 0
                  ? arrCabang.map((item) => item?.value)
                  : null,
                noPeriod: filter?.noPeriod === null ? null : filter?.noPeriod?.value
            }
          : this.state.search;

        this.setState((prevValue) => ({
          ...prevValue,
          pagination: {
            ...prevValue.pagination,
            count: 0,
            page: 1,
            limit: limit,
          },
        }));
        await this.fetchData({...removeNullFields(activeFilter),page: 1, limit: limit});
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async (body) => {
        let req = body && Object.keys(body).length > 0 ?
            body :
            {page: 1, limit: 5}
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterPackageFindByParam,
            menuName: "Master Paket Penjualan",
            setError: this.props.setError,
            args: req
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    count: res.data.totalData,
                    page: req.page,
                    limit: req.limit,
                }
            }));
        }
    }

    refetch = async () =>{
        const filter = this.state.submitedFilter || {}
        const arrCabang = filter.cabangBerlaku;
        const activeFilter = this.state.submitedFilter
          ? {
              ...filter,
              cabangBerlaku:
                arrCabang.length > 0
                  ? arrCabang.map((item) => item?.value)
                  : null,
                noPeriod: filter?.noPeriod === null ? null : filter?.noPeriod?.value
            }
          : this.state.search;

        await this.fetchData({
            ...removeNullFields(activeFilter),
            page: this.state.pagination.page,
            limit: this.state.pagination.limit
        });
    }

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Package",
            setError: this.props.setError,
            args: args,
        })
    };

    handleFilterModalVisibility = () => {
        this.setState(prev => ({ ...prev, filterVisible: !prev.filterVisible}))
    }

    handleSubmitFilter = async (payload) => {
        this.handleTriggerLoading();
        const arrCabang = payload?.cabangBerlaku || []
        this.setState((prev) => ({
          ...prev,
          submitedFilter: payload,
          pagination: { ...prev.pagination, page: 1 },
          filterVisible: false,
          search: {
            packageName: null
          }
        }));
        await this.fetchData({
          ...removeNullFields({
            ...payload,
            cabangBerlaku:
              arrCabang.length > 0
                ? arrCabang.map((item) => item?.value)
                : null,
            noPeriod: payload?.noPeriod === null ? null : payload?.noPeriod?.value,
          }),
          page: 1,
          limit: this.state.pagination.limit,
        });
        this.handleTriggerLoading();
    }

    handleInputPackageName = (value) => {
        this.setState({ search: { packageName: value }})
    }

    handleSearchPackageName = async () => {
        this.handleTriggerLoading();
        this.setState((prev) => ({
          ...prev,
          submitedFilter: null,
          pagination: { ...prev.pagination, page: 1 },
          filterVisible: false,
        }));
        await this.fetchData(removeNullFields({
          [this.state.mainPageFilter?.key?.value]: this.state.mainPageFilter?.value,
          page: 1,
          limit: this.state.pagination?.limit,
        }));
        this.handleTriggerLoading();
    }

    render() {
        return (
            <Container>
                <FlexView
                    style={{ justifyContent: "space-between" }}
                    vAlignContent="center"
                    className="margin-bottom-20px margin-top-5px"
                >
                    <FlexView vAlignContent="center" style={{gap:"20px"}}>
                        <SimpleDDL
                            id="select_key"
                            name="key"
                            box="search"
                            isClearable
                            containerclassname="margin-top-15px width width-250px"
                            options={[
                                {label: "Kode Varian", value: "kodeVariant"},
                                {label: "Nama Paket", value: "packageName"},
                            ]}
                            value={this.state.mainPageFilter.key}
                            onChange={(value, {name}) => {
                                this.setState((prev) => ({
                                  ...prev,
                                  mainPageFilter: {
                                    ...prev.mainPageFilter,
                                    [name]: value,
                                    ...(!value ? {value: null}: {})
                                  },
                                }));
                            }}
                        />
                        <SimpleInput
                          placeholder={
                            !this.state.mainPageFilter.key?.value
                              ? " "
                              : this.state.mainPageFilter.key?.value === "kodeVariant"
                                ? "Masukkan Kode Varian"
                                : "Masukkan Nama Paket"
                          }
                          containerclassname="margin-bottom-5px"
                          id="input_text_package_name"
                          readOnly={!this.state.mainPageFilter.key}
                          value={this.state.mainPageFilter.value}
                          onChange={({ target }) => {
                            this.setState((prev) => ({
                              ...prev,
                              mainPageFilter: {
                                ...prev.mainPageFilter,
                                value: target.value,
                              },
                            }));
                          }}
                        />
                        <SimpleButton
                            onClick={this.handleSearchPackageName}
                            text="CARI"
                        />
                    </FlexView>
                    <SimpleButton
                      onClick={this.handleFilterModalVisibility}
                      styles={{ width: "unset" }}
                      icon={<i className={"fa fa-qrcode"}></i>}
                    />
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableColumns}
                    toCount={this.state.pagination.count}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(
                        (tableState) => this.handleChangePage(tableState),
                        (tableState) => this.handleChangeRowsPerPage(tableState),
                    )}
                    footerAdditionalButtons={
                        <SimpleButton
                            onClick={() => this.handleModifyingModalVisibility()}
                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                            text={"Tambah"}
                        />
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterPackageModifying
                        {...this.props}
                        formGroup={formGroup}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSaveClick}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                {this.state.warningVisible && (
                    <SimpleAlert
                        title={"Question"}
                        content={"Apakah anda yakin?"}
                        additionalButtons={
                            <Fragment>
                                <FlexView>
                                    <SimpleButton
                                        text="Batal"
                                        secondary
                                        onClick={() => this.handleWarningModalVisibility()}
                                    />
                                    <SimpleButton
                                        text="Iya"
                                        onClick={() => this.handleSubmit()}
                                    />
                                </FlexView>
                            </Fragment>
                        }
                        visible={this.state.warningVisible}
                        onClickClose={this.handleWarningModalVisibility}
                    />
                )}

                {this.state.copyVisible && (
                    <SimpleModal
                        visible={this.state.copyVisible}
                        onClickClose={() => this.handleCopyModalVisibility()}
                        styles={{
                            width: "600px",    
                            minWidth: "600px",
                        }}
                        content={
                            <ModalContainer style={{padding: "20px"}}>
                                <form onSubmit={this.handleCopy}>
                                    <SimpleInput
                                        id="input_text_nama_package"
                                        name="packageName"
                                        label="Nama Paket"
                                        mandatory
                                        errorMessage={this.state.errorMessage}
                                        value={this.state.inputValue}
                                        onChange={this.handleValueChange}
                                    />
                                    <div style={{display: "flex", justifyContent: "center", marginTop: "20px"}}>
                                        <SimpleButton type="submit">SIMPAN</SimpleButton>
                                    </div>
                                </form>
                            </ModalContainer>
                        }
                    />
                )}

                {
                    this.state.filterVisible && (
                        <MasterPackageFilter
                            {...this.props}
                            visible={this.state.filterVisible}
                            submitedFilter={this.state.submitedFilter}
                            onClickClose={this.handleFilterModalVisibility}
                            triggerLoading={this.handleTriggerLoading}
                            onSubmit={this.handleSubmitFilter}
                        />
                    )
                }


                <SimpleLoadingOverlay active={this.state.loading}/>
            </Container>

        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterPackage);